import { tlwTwMerge } from '@trg/utils';
import { Link, type LinkProps } from '@trg/tlw-ui-component';
import { useLayoutStore } from '../../../layout';
import type { CategoryAd } from '../../api';

export type BrandLinkProps = Omit<
  LinkProps,
  'href' | 'target' | 'title' | 'children'
> & {
  categoryAd: CategoryAd;
};

export function BrandLink({ categoryAd, className, ...props }: BrandLinkProps) {
  const isDesktop = useLayoutStore.use.isDesktop();

  return (
    <Link
      className={tlwTwMerge(
        'tlw-block tlw-h-full tlw-aspect-[43/34]',
        className
      )}
      href={categoryAd.link}
      target={categoryAd.linkTarget}
      title={categoryAd.mainHeading}
      {...props}
    >
      <img
        className="tlw-size-full tlw-object-cover"
        src={
          isDesktop
            ? categoryAd.imageMediasUrl
            : categoryAd.mobileImageMediasUrl
        }
        alt={categoryAd.mainHeading}
      />
    </Link>
  );
}
